module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/homes_hirono-05507ba9e3970dad4d6494d0df8c630e.jpg";